import React from 'react';
import clsx from 'clsx';
import { FormControlMeta } from './FormControlMeta.js';
import { Label } from './Label.js';
export const FormControlLayout = ({ name, label, secondaryLabel, tertiaryLabel, helperText, error, invalid, hidden, className, children, }) => {
    return (React.createElement("div", { className: clsx('space-y-1', className), hidden: hidden },
        !!label || !!secondaryLabel || !!tertiaryLabel ? (React.createElement(Label, { htmlFor: name, secondaryLabel: secondaryLabel, tertiaryLabel: tertiaryLabel }, label)) : null,
        React.createElement("div", { className: "space-y-2" },
            children,
            React.createElement(FormControlMeta, Object.assign({}, { helperText, error, invalid })))));
};
//# sourceMappingURL=FormControlLayout.js.map